import { VxeFormItem } from 'vxe-pc-ui';
export default {
  name: 'XFormItem',
  components: {
    VxeFormItem
  }
};